import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { f5ThrottleEnabled, f5StoreFullMessage, disableTLSCheck } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "f5ThrottleEnabled", defaultChecked: f5ThrottleEnabled == null ? void 0 : f5ThrottleEnabled.value, onChange }),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "f5StoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: f5StoreFullMessage == null ? void 0 : f5StoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("f5networks.fields.store_full_message_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "disableTLSCheck",
        type: "checkbox",
        value: "disable-TLSCheck",
        defaultChecked: disableTLSCheck == null ? void 0 : disableTLSCheck.value,
        onChange,
        label: t("f5networks.fields.disable_tls_validation"),
        help: t("f5networks.fields.disable_tls_validation_help")
      }
    )
  );
};
export default FormAdvancedOptions;
